import { render } from "./GuestCategoryTable.vue?vue&type=template&id=15ae4292&scoped=true"
import script from "./GuestCategoryTable.vue?vue&type=script&lang=js"
export * from "./GuestCategoryTable.vue?vue&type=script&lang=js"

import "./GuestCategoryTable.vue?vue&type=style&index=0&id=15ae4292&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src141758530/src/mavent-project-vuejs-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ae4292"]])

export default __exports__